import React, {useState, useContext, useEffect} from "react";
import {Link, useNavigate, Navigate, useSearchParams} from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import loginimg from "../../assets/images/track.jpg";
import BLimg from "../../assets/images/betterLife.png";
import BGimg from "../../assets/images/bgLogo.svg";
import {
    CustomButton,
    CustomText,
    CustomTextField,
    CustomTitle,
} from "../../components/Custom";
import {useFormik} from "formik";
import Service from "../../services";
import {AppContext} from "../../context";

const bgSignOn = process.env.REACT_APP_BGSIGNONURL_DEV;

const LoginPage = () => {
    const appdata = useContext(AppContext);
    const [isAuth, setIsAuth] = appdata[0];
    const [userInfo, setUserInfo] = appdata[1];
    const [userRole, setUserRole] = appdata[2];
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();
    const [loginError, setLoginError] = useState();

    const [searchParams, setSearchParams] = useSearchParams({});

    const userTok = searchParams.get("userToken");
    const [tokenPresent, setTokenPresent] = useState(false);

    useEffect(() => {
        console.log(userTok,'userTok')
        if (userTok && userTok.length > 0) {
            sessionStorage.setItem("SSOToken", userTok);

            window.location.replace(`${window.location.origin}`);
        }
    }, []);

    useEffect(() => {
        tryLogin()
    }, [tokenPresent]);

    const tryLogin = () => {
        if (sessionStorage.getItem("SSOToken") === null) {
            setTokenPresent(false);
            //change localhost to sso auth urlz
            window.location.replace(`${bgSignOn}?appUrl=${window.location.origin}`);
        } else {
            setTokenPresent(true);
            handleLogin();
        }
    }

    const formik = useFormik({
        initialValues: {
            staff_id: "",
            password: "",
        },

        // validationSchema: validationSchema,
        onSubmit: (values) => {
            // alert(JSON.stringify(values, null, 4));

            handleLogin(values);
        },
    });

    async function login() {
        const response = await Service.login();
        console.log(response);
        if (response.status === 200 || response.status === 201) {
            const userData = response.data.data;
            // const userToken = response.data.data.token;
            // setIsLoggedIn(true);
            setIsAuth(true);
            
            setUserRole(userData?.level);
            setUserInfo(userData);
            sessionStorage.setItem("user", userData?.staff_id);
            sessionStorage.setItem("userDetails", JSON.stringify(userData));
            console.log("reroute");
            navigate("/view-request");
            // setUserInfo(userData);
        } else {
            console.log(response);
            setLoginError("Invalid Credentials");
        }
    }

    async function handleLogin() {
        const response = await Service.login();
        console.log(response,"login");
        if (response?.status === 200 || response?.status === 201) {
            const userData = response.data.data;
            // const userToken = response.data.data.token;
            // setIsLoggedIn(true);
            setIsAuth(true);
            console.log(userData, "userData")
            setUserRole(userData?.level);
            setUserInfo(userData);
            sessionStorage.setItem("user", userData?.staff_id);
            sessionStorage.setItem("userDetails", JSON.stringify(userData));
            console.log("reroute");
            navigate("/view-request");
            // setUserInfo(userData);
        } else {
            console.log(response);
            setLoginError("Invalid Credentials");
        }
    }

    console.log(isLoggedIn);
    // console.log(isAuth);
    const [values, setValues] = useState({
        showPassword: false,
    });

    const handleClickShowPassword = () => {
        setValues({
            ...values,
            showPassword: !values.showPassword,
        });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    if (isLoggedIn) {
        return <Navigate to="/dashboard"/>;
    }
    return (
        <Box>
            <Box py={5} px={15}>
                <Grid
                    container
                    component="main"
                    sx={{height: "650px", border: "2px solid", borderRadius: "5px"}}
                >
                    <CssBaseline/>

                    <Grid
                        item
                        xs={false}
                        sm={7}
                        md={7}
                        sx={{
                            backgroundImage: `url(${loginimg})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "800px",
                            height: "100%",
                            backgroundPosition: "center",

                            // backgroundBlendMode: "multiply",
                        }}
                    >
                        <Grid
                            container
                            sx={{
                                backgroundColor: "rgba(220, 220, 220, 0.4)",
                                height: "100%",
                                textAlign: "center",
                            }}
                        >
                            <Box>
                                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                                    <Box
                                        component="img"
                                        sx={{
                                            height: 130,
                                            width: 120,
                                            p: 1,
                                            // maxHeight: { xs: 233, md: 167 },
                                            // maxWidth: { xs: 250, md: 150 },
                                        }}
                                        alt="Babbangona logo"
                                        src={BGimg}
                                    />
                                    <Box
                                        component="img"
                                        sx={{
                                            height: 120,
                                            width: 110,
                                            mx: 1,
                                            // maxHeight: { xs: 233, md: 167 },
                                            // maxWidth: { xs: 250, md: 150 },
                                        }}
                                        alt="Better Life"
                                        src={BLimg}
                                    />
                                </Box>

                                <CustomTitle
                                    sx={{fontSize: "75px", lineHeight: "80px", mt: 6}}
                                >
                                    Data Request Tracker
                                </CustomTitle>
                                <CustomText sx={{px: 2, fontWeight: "600"}}>3.0</CustomText>
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={5}
                        md={5}
                        component={Paper}
                        elevation={2}
                        square
                    >
                        {/* <img
            src={BLimg}
            alt="better life"
            height="20%"
            style={{ position: "absolute", top: "0px", right: "0px" }}
          /> */}
                        <Box
                            sx={{
                                py: 10,
                                px: 8,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "left",
                            }}
                        >
                            {/* <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
             <LockOutlinedIcon />
           </Avatar> */}
                            <form onSubmit={formik.handleSubmit}>
                                <CustomTitle
                                    component="h1"
                                    variant="h4"
                                    sx={{mb: 5, fontSize: "35px"}}
                                >
                                    Sign in
                                </CustomTitle>
                                <CustomText component="p" variant="subtitle">
                                    Logging In via BG SSO
                                </CustomText>
                                <Box noValidate sx={{mt: 1}}>
                                    {/* <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              /> */}

                                    {loginError && (
                                        <p style={{color: "red"}}>
                                            You are not authorized to view this page. Please try again
                                        </p>
                                    )}

                                    {loginError && (
                                        <CustomButton
                                            onClick={tryLogin}
                                            fullWidth
                                            variant="contained"
                                            sx={{
                                                my: 4,
                                                background: "#58CC02",
                                            }}
                                        >
                                            Login
                                        </CustomButton>
                                    )}

                                    <Grid
                                        container
                                        sx={{
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >

                                    </Grid>
                                </Box>
                            </form>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};
export default LoginPage;
